module.exports = __webpack_public_path__ + "img/purchase-3_2.292b5fa4.png";